import {Component, OnInit} from '@angular/core';
import {VeiculosCorridaService} from "./veiculos-corrida.service";
import {VeiculosCorridaModel} from "./veiculos-corrida.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UsuariosService} from "../usuarios/usuarios.service";
import {VeiculosService} from "../veiculos/veiculos.service";

declare let swal, $: any;

@Component({
  selector: 'app-veiculos-corrida',
  templateUrl: './veiculos-corrida.component.html'
})
export class VeiculosCorridaComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {
    "veiculo": "",
    "motorista": "",
    "data_inicio": "",
    "data_termino": "",
    "ordem_campo": "inicio",
    "ordem_direcao": "d"
  };

  formTrocaOleo: FormGroup;
  listVeiculosCompleto = [];
  veiculoSelecionado: any = null;
  trocaOleoData = { id_veiculo: '', km_troca_oleo: null };

  corridas: VeiculosCorridaModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listVeiculos = [];
  listMotoristas = [];

  userInfo = {};

  constructor(
    formBuilder: FormBuilder,
    private veiculosService: VeiculosService,
    private veiculosCorridaService: VeiculosCorridaService,
    private usuariosService: UsuariosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    private route: ActivatedRoute,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      this.userInfo = data;
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'veiculos-corridas'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      veiculo: [],
      motorista: [],
      data_inicio: [],
      data_termino: []
    });

    this.formTrocaOleo = formBuilder.group({
      id_veiculo: ['', Validators.required],
      km_troca_oleo: ['', Validators.required]
    });

    this.usuariosService.get(null, null, ['id_usuario', 'nome'])
      .subscribe(
        json => {
          this.listMotoristas = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.veiculosService.get(null, null, ['id_veiculo', 'placa'])
      .subscribe(
        json => {
          this.listVeiculos = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.veiculosService.get(null, null, ['id_veiculo', 'placa', 'km_troca_oleo'])
      .subscribe(
        json => {
          this.listVeiculosCompleto = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = Object.assign(this.filtroPesquisa, filtroSalvo);
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }

    this.route.queryParams.subscribe(paramsGet => {
      if (paramsGet['veiculo'] && !this.filtroPesquisa.veiculo) {
        this.filtroPesquisa.veiculo = paramsGet['veiculo'];
        this.formPesquisaAvancada.patchValue({ veiculo: paramsGet['veiculo'] });
      }
      this.getPage(1);
    });
  }

  setOrdem(campo: string) {
    if (this.filtroPesquisa.ordem_campo === campo) {
      this.filtroPesquisa.ordem_direcao = (this.filtroPesquisa.ordem_direcao === 'a') ? 'd' : 'a';
    } else {
      this.filtroPesquisa.ordem_campo = campo;
      this.filtroPesquisa.ordem_direcao = 'a';
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
  }

  delete(corrida) {
    let corridas = this.corridas;
    let veiculosCorridaService = this.veiculosCorridaService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarCorridaVeiculo'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(corridas);
        }

        let index = corridas.indexOf(corrida);
        corridas.splice(index, 1);

        veiculosCorridaService.apagar(corrida.id_corrida)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.corridas = corridas;
            },
            err => {
              // Revert the view back to its original state
              corridas.splice(index, 0, corrida);
              self.corridas = corridas;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.filtroPesquisa.motorista != '') {
      filtros['id_usuario'] = this.filtroPesquisa.motorista;
    }

    if (this.filtroPesquisa.veiculo != '') {
      filtros['id_veiculo'] = this.filtroPesquisa.veiculo;
    }

    if (this.filtroPesquisa.data_inicio && this.filtroPesquisa.data_termino) {
      filtros['inicio'] = 'bt:' + this.filtroPesquisa.data_inicio + '|' + this.filtroPesquisa.data_termino + 'T23:59:59';
    } else {
      if (this.filtroPesquisa.data_inicio) {
        filtros['inicio'] = 'ge:' + this.filtroPesquisa.data_inicio;
      }

      if (this.filtroPesquisa.data_termino) {
        filtros['inicio'] = 'le:' + this.filtroPesquisa.data_termino + 'T23:59:59';
      }
    }

    let sort = {};
    let campoSort = this.filtroPesquisa.ordem_campo || 'inicio';
    let direcaoSort = this.filtroPesquisa.ordem_direcao || 'd';
    sort[campoSort] = direcaoSort;

    this.veiculosCorridaService.getPaginacao(pagina, this.itensPorPagina, ["usuario", "veiculo"], filtros, null, sort)
      .subscribe(data => {
          this.corridas = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    if (this.filtroPesquisa.data_inicio && !this.filtroPesquisa.data_termino) {
      this.filtroPesquisa.data_termino = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {
      "veiculo": "",
      "motorista": "",
      "data_inicio": "",
      "data_termino": "",
      "ordem_campo": "inicio",
      "ordem_direcao": "d"
    };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  abrirModalTrocaOleo(){
    this.trocaOleoData = { id_veiculo: '', km_troca_oleo: null };
    this.veiculoSelecionado = null;
    this.formTrocaOleo.reset({ id_veiculo: '', km_troca_oleo: '' });
    $('#modalTrocaOleo').modal('show');
  }

  onVeiculoTrocaChange(e){
    if (e && e !== 'null') {
      for (let i in this.listVeiculosCompleto) {
        if (this.listVeiculosCompleto[i].id_veiculo === e) {
          this.veiculoSelecionado = this.listVeiculosCompleto[i];
          this.trocaOleoData.km_troca_oleo = this.veiculoSelecionado.km_troca_oleo;
          this.formTrocaOleo.patchValue({ km_troca_oleo: this.veiculoSelecionado.km_troca_oleo });
          break;
        }
      }
    } else {
      this.veiculoSelecionado = null;
      this.trocaOleoData.km_troca_oleo = null;
      this.formTrocaOleo.patchValue({ km_troca_oleo: '' });
    }
  }

  isKmOleoInvalido(): boolean {
    if (!this.veiculoSelecionado || this.trocaOleoData.km_troca_oleo === null || this.trocaOleoData.km_troca_oleo === '') {
      return false;
    }
    const kmAtual = parseFloat(this.trocaOleoData.km_troca_oleo);
    const kmUltimo = parseFloat(this.veiculoSelecionado.km_troca_oleo);
    return isNaN(kmAtual) || kmAtual < kmUltimo;
  }

  confirmarTrocaOleo(){
    if (!this.formTrocaOleo.valid || this.isKmOleoInvalido()) {
      return;
    }
    
    let km = this.trocaOleoData.km_troca_oleo;

    this.veiculosService.updateOleo(this.trocaOleoData.id_veiculo, km)
      .subscribe(
        json => {
          $('#modalTrocaOleo').modal('hide');
          swal(
            this.func.traduzir('front.sucesso'),
            this.func.traduzir('front.trocaOleoRegistradaSucesso'),
            "success"
          );
          this.getPage(1);
          // Refresh vehicle list to get updated KM
          this.veiculosService.get(null, null, ['id_veiculo', 'placa', 'km_troca_oleo'])
            .subscribe(
              res => {
                this.listVeiculosCompleto = res.Payload;
              },
              error => {
                this.func.showErro(error.json());
              });
        },
        error => {
          this.func.showErro(error.json());
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/veiculos-corrida/veiculos-corrida.component.ts